<template>
  <v-container fluid class="no-data-info text-center">
    <div class="d-flex justify-center">
      <span class="mb-12 icon-holder">
        <slot name="icon"></slot>
      </span>
    </div>
    <h1 class="mb-0" v-if="$slots.title">
      <slot name="title"></slot>
    </h1>
    <p class="mb-15 grey--text text--darken-2" v-if="$slots.text">
      <slot name="text"></slot>
    </p>
    <!-- <v-btn
      v-if="homePageBtn"
      to="/fooldal/"
      color="primary"
      outlined
      block
      large
      class="mt-15"
    >
      Vissza
    </v-btn> -->
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'k-nodata-info',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  props: {
    homePageBtn: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
